function ConvertToInDepthSetMenuItem(inDepthSet) {
    const totalQuestions = inDepthSet.filterSets 
        ? inDepthSet.filterSets.reduce((sum, fs) => sum + (fs.questions ? fs.questions.length : 0), 0)
        : 0;
    return {
        id: inDepthSet.id,       
        name: inDepthSet.name,
		startDate: inDepthSet.startDate,
		endDate: inDepthSet.endDate,
		folderId: inDepthSet.folderId,
		questionsCount: totalQuestions,
        filterCount: inDepthSet.filterSets ? inDepthSet.filterSets.length : 0,
        inArchive: inDepthSet.filterSets ? (inDepthSet.filterSets.every(fs => fs.inArchive === 1) ? 1 : 0) : 0
      }
}
export default ConvertToInDepthSetMenuItem;